import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent {

  @ViewChild('header')
  private headerRef: ElementRef;

  @Input() header: boolean = true;

  constructor(private ref: ElementRef) {
  }

  public render() {
    if (this.ref.nativeElement.hasAttribute('center')) return;

    this.headerRef.nativeElement.classList.remove('center');
    let divs = (this.headerRef.nativeElement as HTMLElement).children;

    let rects: DOMRect[] = [divs[0].getBoundingClientRect() as DOMRect, divs[1].getBoundingClientRect() as DOMRect];

    if (rects[0].y + rects[0].height < rects[1].y) {
      this.headerRef.nativeElement.classList.add('center');
    }
  }
}
